import React from 'react';
import { Navigate } from 'react-router-dom';
import { getUser, setReturnURL } from '../../../utils/commonfunction';
import { ROLE } from "../../../utils/Constants";
import { useSelector } from "react-redux";

const AdvertiserProfileSetupRoute = ({ component: Component }) => {
    const profileData = useSelector((state) => state.profile.profileData);

    // Check both advertiser and user (for become-advertiser flow)
    const storedAdvertiserData = getUser(ROLE.ADVERTISER);
    const storedUserData = getUser(ROLE.USER);

    const advertiserData = { ...storedAdvertiserData, ...(profileData?.role === ROLE.ADVERTISER ? profileData : {}) };
    const userData = { ...storedUserData, ...(profileData?.role === ROLE.USER ? profileData : {}) };
// console.log(userData,"sd232332");

    const isUserLoggedIn = profileData?.role === ROLE.USER || (userData && userData.token && (!storedAdvertiserData || !storedAdvertiserData.token));
    const isAdvertiserLoggedIn = !isUserLoggedIn && advertiserData && advertiserData.token;

    return (
        <>
            {(function () {
                if (isUserLoggedIn) {
                    // User become-advertiser flow: allow if not yet registered business
                    if (!userData.isBusinessRegistered) {
                        return <Component />
                    } else if (!userData.isKycRegistered) {
                        return <Navigate to="/advertiser/kyc-details" />;
                    } else {
                        // Already submitted — redirect to success page
                        return <Navigate to="/advertiser/success-submitted" />;
                    }
                } else if (isAdvertiserLoggedIn) {
                    // Regular advertiser flow
                    if (!advertiserData.isBusinessRegistered) {
                        return <Component />
                    } else if (!advertiserData.isKycRegistered) {
                        return <Navigate to="/advertiser/kyc-details" />;
                    } else {
                        return <Navigate to="/advertiser/success-submitted" />;
                    }
                } else {
                    setReturnURL(ROLE.USER);
                    return <Navigate to="/user/login" />;
                }
            })()}
        </>
    )
}

export default AdvertiserProfileSetupRoute;